module.exports = __webpack_public_path__ + "img/konfigurator_blotniki.6f8c0b90.svg";